// @flow
import * as types from "../ACTIONS/actionTypes";
import initialState from "./initialState";

export default function magTypeReducer(state = initialState.magTypes, action) {

    switch (action.type) {
        
        // GOTMAGTYPE_LIST - moved to commonReducer
        case types.ADD_NEW_MAG_TYPE: {
            const updatedMagTypes = [...state.items, action.magType];
            return {
                initialized: true,
                items: updatedMagTypes
            };
        }
        case types.REMOVE_MAG_TYPE: {
            const updatedMagTypes = state.items.filter(p => p.id !== action.id);
            return {
                initialized: true,
                items: updatedMagTypes
            };
        }
        case types.UPDATE_MAG_TYPE: {
            const updatedMagTypes = state.items.filter(p => p.id !== action.id);
            updatedMagTypes.push(action.magType); // read add.
            return {
                initialized: true,
                items: updatedMagTypes
            };
        }
        default:
            return state;
    }
}
    